import axiosInstance from '../utils/axios-instance';
import { actionCreator, createRequestTypes, getErrorMessage } from '../utils/helpers';
import { dispatchClearAction } from "src/actions/_utils";


export const GET_CLOUDWATCH_LOGS = createRequestTypes('GET_CLOUDWATCH_LOGS');
export const GET_CLOUDWATCH_STREAM = createRequestTypes('GET_CLOUDWATCH_STREAM');

export const getCloudWatchLogs = (data) => async (dispatch) => {
  dispatch(actionCreator.request(GET_CLOUDWATCH_LOGS));
  try {
    const response = await axiosInstance.post(`/admin/cloudwatch/log-events`, data);
    dispatch(actionCreator.success(GET_CLOUDWATCH_LOGS, response.data));
    return response.data;
  } catch (err) {
    dispatch(actionCreator.failure(GET_CLOUDWATCH_LOGS, getErrorMessage(err)));
    return err.response;
  }
};



export const clearCloudWatchLogs = () => dispatchClearAction(GET_CLOUDWATCH_LOGS);


export const getCloudWatchStream = () => async (dispatch) => {
  dispatch(actionCreator.request(GET_CLOUDWATCH_STREAM));
  try {
    const response = await axiosInstance.get(`/admin/cloudwatch/log-streams`);
    dispatch(actionCreator.success(GET_CLOUDWATCH_STREAM, response.data));
    return response.data;
  } catch (err) {
    dispatch(actionCreator.failure(GET_CLOUDWATCH_STREAM, getErrorMessage(err)));
    return err.response;
  }
};
